export default __webpack_public_path__ + "static/media/developers-package.1d351807.png";